import { getOrgConfig, defaultAmountField } from "../../../Common/Hooks/OrgConfigHooks";
import { useState, useEffect } from 'react';
import { APIClient } from "../../../helpers/api_helper";
import { Card, Col, Row, Form } from 'antd';
import IncomeVsExpenseBarChart from '../../../Charts/IncomeVsExpenseBarChart';
import IncomeVsExpenseTable from './IncomeVsExpenseTable';
import IntentAggregations from '../../../Common/IntentAggregations';
import AggregationPeriodSelect from '../../../Common/AggregationPeriodSelect';
import AmountFieldSelect from '../../../Common/AmountFieldSelect';
import { useSelector, useDispatch } from "react-redux";
import utils from '../../../Common/utils';
import { updateFilterData } from '../../../slices/filters/thunk';

const api = new APIClient();

// staticParams: fixed params (e.g. { projects: [id] }) — merged with dynamic params like aggregation_period.
// When omitted, filterdata from Redux drives all params (standard Insights page behaviour).
const IncomeVsExpenseView = ({ staticParams }) => {
  const dispatch = useDispatch();
  const filterdata = useSelector((state) => state.Filterdata.data);
  const [incomeExpenseData, setIncomeExpenseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [intentAggsData, setIntentAggsData] = useState({});
  const [localAggregationPeriod, setLocalAggregationPeriod] = useState('month');
  const [localAmountField, setLocalAmountField] = useState(defaultAmountField(getOrgConfig()));

  const loadData = (params) => {
    setLoading(true);
    api.get('/api/insights/income_expense/', params)
      .then(resp => setIncomeExpenseData(resp))
      .finally(() => setLoading(false));
    api.get('/api/insights/current_income_expense_sums/', params).then(resp => {
      setIntentAggsData(resp);
    });
  };

  useEffect(() => {
    if (staticParams) {
      loadData({
        ...staticParams,
        aggregation_period: localAggregationPeriod,
        amount_field: localAmountField,
      });
    }
  }, [JSON.stringify(staticParams), localAggregationPeriod, localAmountField]);

  useEffect(() => {
    if (!staticParams) {
      loadData(utils.getObjectFromURL());
    }
  }, [filterdata]);

  const aggregationPeriod = staticParams ? localAggregationPeriod : (filterdata.aggregation_period || 'month');
  const onAggregationPeriodChange = staticParams
    ? setLocalAggregationPeriod
    : val => dispatch(updateFilterData({ aggregation_period: val }));

  const amountField = staticParams ? localAmountField : (filterdata.amount_field || defaultAmountField(getOrgConfig()));
  const onAmountFieldChange = staticParams
    ? setLocalAmountField
    : val => dispatch(updateFilterData({ amount_field: val }));

  return (
    <Col xs={24} className="gutter-row">
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item label="Obdobje agregacije">
              <AggregationPeriodSelect
                value={aggregationPeriod}
                onChange={onAggregationPeriodChange}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="Znesek">
              <AmountFieldSelect
                value={amountField}
                onChange={onAmountFieldChange}
              />
            </Form.Item>
          </Col>
        </Row>
      <Card>
        <IntentAggregations data={intentAggsData} />
        <IncomeVsExpenseBarChart data={incomeExpenseData} />
        <IncomeVsExpenseTable data={incomeExpenseData} loading={loading} />
      </Card>
    </Col>
  );
};

export default IncomeVsExpenseView;
